import React from 'react';
import SystemSettings from './SystemSettings';
import ItemDisable from './ItemDisable';
import SystemMessage from "./SystemMessage";
import PaymentMethodSettings from "./PaymentMethodSettings"; // Hinzugefügt

// System settings layout wrapping administrative components
const Settings = () => {
    return (
        <div className="flex flex-col gap-8 p-4 max-w-7xl mx-auto">
            <SystemMessage/>
            <section>
                <h1 className="text-3xl font-black mb-6 text-gray-900 dark:text-white uppercase tracking-tighter">
                    System Administration
                </h1>
                <SystemSettings/>
            </section>

            <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-neutral-200">
                    Item Inventory Restrictions
                </h2>
                <ItemDisable/>
            </section>
        </div>
    );
};

export default Settings;